var ko = require('knockout'),
  APIHelper = require('_js/APIHelper');

function RegistrationInsurance(params) {
  var self = this;

  if (params.step === undefined) {
    throw 'No steps parameter passed to this component!';
  }

  self.parent = params.parent;

  self.step = params.step;
  self.API = params.api;
  self.currentStep = ko.observable(self.parent.currentStep());
  // Determine if this page is the current step.
  self.parent.currentStep.subscribe(function(val) {
    if (val === self.step()) {
      self.activateComponent();
    }
  });

  self.isLoading = ko.observable(false);

  self.showAboutProfessionInsurance = ko.observable(false);
  self.showAboutCrimeInsurance = ko.observable(false);
  self.crimeInsuranceConfirmation = ko.observable(false);

  self.hasInsurance = ko.observable().extend({
    required: [
      {
        type: 'isCheckedOff',
        message: self.parent.errorMessages.noAlternativeChosen
      }
    ]
  });

  self.requiredFields = [self.hasInsurance];

  self.toggleUploadInsurance = ko.observable();

  self.uploadInsuranceText = ko.observable();

  self.externalInsuranceId = ko.observable().extend({
    required: [
      {
        type: 'isNotEmpty',
        message: self.parent.errorMessages.requiredFieldEmpty
      }
    ]
  });
  self.externalInsuranceFileName = null;

  self.hasInsurance.subscribe(function(hasInsurance) {
    // hasInsurance is a string, and not a boolean.
    if (hasInsurance === 'true') {
      self.requiredFields = [self.hasInsurance, self.externalInsuranceId];
    } else {
      self.requiredFields = [self.hasInsurance, self.professionInsuranceId];
    }
  });

  self.crimeInsuranceConfirmation.subscribe(function(hasCrimeInsurance) {
    if (hasCrimeInsurance) {
      self.requiredFields = [
        self.professionInsuranceId,
        self.criminalInsuranceId,
        self.totalSalaryCost
      ];
    } else {
      self.requiredFields = [self.professionInsuranceId];
    }
  });

  self.professionInsurances = ko.observableArray();
  self.criminalInsurances = ko.observableArray();

  self.professionInsuranceId = ko.observable().extend({
    required: [
      {
        type: 'isPositiveNumber',
        message: self.parent.errorMessages.noAlternativeChosen
      }
    ]
  });
  self.criminalInsuranceId = ko.observable().extend({
    required: [
      {
        type: 'isPositiveNumber',
        message: self.parent.errorMessages.noAlternativeChosen
      }
    ]
  });

  self.headCount = 0;
  self.totalSalaryCost = ko.observable().extend({
    required: [
      {
        type: 'isPositiveNumber',
        message: self.parent.errorMessages.invalidSalaryCost
      }
    ]
  });

  var regData = sessionStorage.getItem('rn-registration');
  if (regData !== undefined && regData !== null) {
    var parsedRegData = JSON.parse(regData);
    if (parsedRegData.insurance !== undefined) {
      this.populateInputFromStore(parsedRegData.insurance);
    }
  }

  self.activateComponent();
}

RegistrationInsurance.prototype.init = function(element) {
  var self = this;
  self.$element = $(element);

  var $hasInsurance = $($(element).find("[data-has-insurance='true']"));
  var $buyInsurance = $($(element).find("[data-has-insurance='false']"));
  self.hasInsurance.subscribe(function(val) {
    if (val === 'true') {
      $buyInsurance.slideUp(250, 'easeOutQuad', function() {
        $hasInsurance.slideDown(250, 'easeOutQuad', function() {});
      });
    } else {
      $hasInsurance.slideUp(250, 'easeOutQuad', function() {
        $buyInsurance.slideDown(250, 'easeOutQuad', function() {});
      });
    }
  });

  var $fileInput = $(self.$element.find('#insurance-upload-input'));
  self.insuranceFile = null;
  $fileInput.on('change', function() {
    self.insuranceFile = this.files[0];
  });
};

RegistrationInsurance.prototype.activateComponent = function() {
  var self = this;
  // Since this is called in the constructor we need to do verify that we are at the correct step.
  if (self.step() === self.parent.currentStep()) {
    self.getHeadCountFromAgency();
    self.getProfessionInsurances();
    self.getCriminalInsurances();
  }
};

RegistrationInsurance.prototype.uploadClick = function() {
  var fileElem = this.$element.find('#fileElem');
  if (fileElem) {
    fileElem.click();
  }
};

RegistrationInsurance.prototype.uploadInsurance = function() {
  var self = this;
  var file = self.insuranceFile;
  var url = self.API.postInsuranceDocument; // + '/' + file.name;
  var xhr = new XMLHttpRequest();

  // If file size is larger than 15 MB.
  if (file.size > 15000000) {
    return;
  }

  xhr.addEventListener('load', function() {
    self.isLoading(false);
    try {
      if (this.responseText) {
        self.uploadInsuranceText('Filen er lastet opp.');
        self.externalInsuranceId(JSON.parse(this.responseText));
        self.externalInsuranceFileName = file.name;
      } else {
        self.uploadInsuranceText('Noe gikk galt, prøv igjen.');
      }
    } catch (err) {
      // console.error("Error uploading: ", err);
      self.uploadInsuranceText('Noe gikk galt, prøv igjen.');
    }
  });

  self.isLoading(true);
  xhr.open('post', url, true);
  xhr.setRequestHeader('Content-Type', 'multipart/form-data');
  xhr.send(file);
};

RegistrationInsurance.prototype.uploadSubmit = function() {};

RegistrationInsurance.prototype.handleFiles = function() {};

RegistrationInsurance.prototype.getHeadCountFromAgency = function() {
  var regData = sessionStorage.getItem('rn-registration');
  if (regData !== undefined && regData !== null) {
    var parsedRegData = JSON.parse(regData);
    if (
      parsedRegData.infoAgency !== undefined &&
      parsedRegData.infoAgency.agency
    ) {
      // Get the headcount in decimals. If the user used "," replace it with "."
      this.headCount = parseFloat(
        parsedRegData.infoAgency.agency.Employees.toString().replace(/,/, '.'),
        10
      );
    }
  }
};

RegistrationInsurance.prototype.getProfessionInsurances = function() {
  var self = this,
    url = self.API.getProfessionInsurances + '?headCounts=' + self.headCount;

  // Only perform the API call if we haven't already done so.
  if (self.professionInsurances().length === 0) {
    APIHelper.get(
      url,
      function(data) {
        self.professionInsurances(data);
      },
      function(response) {
        var location = window.location.href || document.URL;
        APIHelper.post('/api/log/error', {
          message: 'API-error: registration-insurance.js',
          context: location,
          parameters: [
            'windowSize: ' + window.innerWidth + 'x' + window.innerHeight,
            'platform: ' + navigator.platform,
            'responseText: ' + response.responseText,
            'status: ' + response.status,
            'statusText: ' + response.statusText,
            'requestUrl: ' + url
          ]
        });
      }
    );
  }
};

RegistrationInsurance.prototype.getCriminalInsurances = function() {
  var self = this,
    url = self.API.getCriminalInsurances;
  // Only perform the API call if we haven't already done so.
  if (self.criminalInsurances().length === 0) {
    APIHelper.get(
      url,
      function(data) {
        self.criminalInsurances(data);
      },
      function(response) {
        var location = window.location.href || document.URL;
        APIHelper.post('/api/log/error', {
          message: 'API-error: registration-insurance.js',
          context: location,
          parameters: [
            'windowSize: ' + window.innerWidth + 'x' + window.innerHeight,
            'platform: ' + navigator.platform,
            'responseText: ' + response.responseText,
            'status: ' + response.status,
            'statusText: ' + response.statusText,
            'requestUrl: ' + url
          ]
        });
      }
    );
  }
};

RegistrationInsurance.prototype.populateInputFromStore = function(store) {
  this.totalSalaryCost(store.totalSalaryCost);
};

RegistrationInsurance.prototype.createStoreObject = function() {
  var storeObj = {};
  if (
    this.externalInsuranceFileName !== null &&
    this.externalInsuranceId() !== null
  ) {
    storeObj.externalInsuranceId = this.externalInsuranceId();
    storeObj.externalInsuranceFileName = this.externalInsuranceFileName;
  }
  if (this.totalSalaryCost() !== undefined && this.totalSalaryCost() !== null) {
    storeObj.totalSalaryCost = this.totalSalaryCost();
  }
  if (
    this.professionInsuranceId() !== undefined &&
    this.professionInsuranceId() !== null
  ) {
    storeObj.professionInsuranceId = this.professionInsurances()[
      this.professionInsuranceId()
    ].InsuranceId;
  }
  if (
    this.criminalInsuranceId() !== undefined &&
    this.criminalInsuranceId() !== null
  ) {
    storeObj.criminalInsuranceId = this.criminalInsurances()[
      this.criminalInsuranceId()
    ].InsuranceId;
  }
  // Store all the observable values into an object.
  return storeObj;
};

RegistrationInsurance.prototype.storeValues = function() {
  this.parent.storeValuesForStep('insurance', this.createStoreObject());
};

RegistrationInsurance.prototype.validateInputOnStep = function() {
  return this.parent.validateFields(this.requiredFields);
};

RegistrationInsurance.prototype.toggleAboutProfessionInsurance = function() {
  this.showAboutProfessionInsurance(!this.showAboutProfessionInsurance());
};

RegistrationInsurance.prototype.toggleAboutCrimeInsurance = function() {
  this.showAboutCrimeInsurance(!this.showAboutCrimeInsurance());
};

RegistrationInsurance.prototype.previousStep = function() {
  this.parent.previousStep();
};

RegistrationInsurance.prototype.nextStep = function() {
  // 1: Validate step. If successful, goto next step.
  if (!this.validateInputOnStep()) {
    var location = window.location.href || document.URL;
    APIHelper.post('/api/log/error', {
      message: 'NOT-VALIDATED: registration-insurance.js',
      context: location,
      parameters: [
        'windowSize: ' + window.innerWidth + 'x' + window.innerHeight,
        'platform: ' + navigator.platform
      ]
    });
    return;
  }

  // 2: Store values inputted by the user into Storage.
  this.storeValues();

  // 3: Allow to continue execution.
  this.parent.nextStep();
};

module.exports = RegistrationInsurance;
